/**
 * Fixed value sets behind the properties panel's selects.
 *
 * These used to be free-text inputs, which let a typo ("Equals", "post")
 * silently produce CSML that falls through to a default branch or a wrong
 * verb. Values that CSML itself defines are shown verbatim - they are
 * configuration, not UI copy - while anything phrased for a human carries an
 * i18n key instead.
 */

const plain = values => values.map(value => ({ value, label: value }));

export const INPUT_TYPES = plain([
  'text',
  'email',
  'number',
  'tel',
  'url',
  'password',
  'textarea',
]);

export const CALENDAR_MODES = plain(['single', 'range', 'multiple']);

export const HTTP_METHODS = plain(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']);

export const OAUTH_PROVIDERS = plain([
  'google',
  'facebook',
  'github',
  'microsoft',
  'linkedin',
]);

// Operator keys must match the switch in useCsmlGenerator's API branch.
export const RULE_OPERATORS = [
  { value: 'equals', labelKey: 'OPERATORS.EQUALS' },
  { value: 'contains', labelKey: 'OPERATORS.CONTAINS' },
  { value: 'starts', labelKey: 'OPERATORS.STARTS' },
  { value: 'ends', labelKey: 'OPERATORS.ENDS' },
  { value: 'gt', labelKey: 'OPERATORS.GT' },
  { value: 'lt', labelKey: 'OPERATORS.LT' },
  { value: 'exists', labelKey: 'OPERATORS.EXISTS' },
];

export const ASSIGN_TYPES = [
  { value: 'team', labelKey: 'ASSIGN_TYPES.TEAM' },
  { value: 'agent', labelKey: 'ASSIGN_TYPES.AGENT' },
];

// 2024-01-07 is a Sunday, so the index doubles as the date offset used to
// format a locale-aware weekday name.
export const WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
].map(value => ({
  value,
  dayIndex: [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ].indexOf(value),
}));

export function weekdayLabel(dayIndex) {
  return new Intl.DateTimeFormat(undefined, { weekday: 'short' }).format(
    new Date(Date.UTC(2024, 0, 7 + dayIndex))
  );
}
